import React from 'react';
import Header from '../Components/Header/Header';
import ImgCard from '../Components/ImgCard/ImgCard';

import IncreaseSalesImg from "../Images/webp/IncreaseSales.webp";
import CustomerServiceImg from "../Images/webp/CustomerService.webp";
import CostReductionImg from "../Images/webp/CostReduction.webp";
import MLSimg from "../Images/webp/MachineLearningSolutions.webp";
import PredictiveImg from "../Images/webp/PredictiveAnalytics.webp";
import AIdrivenImg from "../Images/webp/AI-DrivenBusiness.webp";
import DecisionsImg from "../Images/webp/Decisions.webp";
import '../Styles/about-us.scss';
import Footer from '../Components/Footer/Footer';
import { useTranslation } from 'react-i18next';

function AboutUs(props) {
  const { t } = useTranslation();

  return (
    <div>
      {/* About us */}
      <div className="about-us">
        <div className="container">
          <div className="row">
            <div className="col-12 col-md-8 col-lg-6 about-text my-120">
              <p className="h3 -b -w">
                {t('aboutKeyPrediction')}
              </p>
              <p className="mt-16">
                {t('empoweringBusinesses')}
              </p>
              <p className="mt-16">
                {t('ourOfferings')}
              </p>
              <p className="mt-16">
                {t('ourGoal')}
              </p>
              <p className="mt-16">
                {t('contactUs')}
                <a href="mailto:miguel@keyprediction.com" className='email'>miguel@keyprediction.com</a>
              </p>
            </div>
          </div>
        </div>
      </div>
      {/* About us */}

      {/* Your business goals */}
      <div name="businessGoals" className="section">
        <div className="p-0">
          <div className="container">
            <div className="row mb-40">
              <div className="col-12">
                <p className="h1 -b">
                  {t('businessGoals')}
                </p>
              </div>
            </div>
            <div className="row card-container">
              <div className="col-hover col-12 col-md-3 mb-24">
                <ImgCard 
                  imgSrc={IncreaseSalesImg}
                  altText={t('mlSolutions')}
                  title={t('increaseSales')}
                  bodyText={t('increaseSalesText')}
                  buttonClasses="-text -lightbg text-s mt-16" 
                  buttonText={t('buttonText')}
                  buttonHref="#get-started"
                />
              </div>
              <div className="col-hover col-12 col-md-3 mb-24">
                <ImgCard 
                  imgSrc={CustomerServiceImg}
                  altText={t('predictiveAnalytics')}
                  title={t('improveCustomerService')}
                  bodyText={t('customerServiceText')}
                  buttonClasses="-text -lightbg text-s mt-16" 
                  buttonText={t('buttonText')}
                  buttonHref="#get-started"
                />
              </div>
              <div className="col-hover col-12 col-md-3 mb-24">
                <ImgCard 
                  imgSrc={CostReductionImg}
                  altText={t('aiBusinessConsulting')}
                  title={t('reduceCosts')}
                  bodyText={t('reduceCostsText')}
                  buttonClasses="-text -lightbg text-s mt-16" 
                  buttonText={t('buttonText')}
                  buttonHref="#get-started"
                />
              </div>
              <div className="col-hover col-12 col-md-3 mb-24">
                <ImgCard 
                  imgSrc={DecisionsImg}
                  altText={t('aiBusinessConsulting')}
                  title={t('takeBetterDecisions')}
                  bodyText={t('decisionsText')}
                  buttonClasses="-text -lightbg text-s mt-16" 
                  buttonText={t('buttonText')}
                  buttonHref="#get-started"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* Your business goals */}

      {/* Services */}
      <div name="services" className="section">
        <div className="p-0 services-section">
          <div className="">
            <div className="container">
              <p className="h1 -b">{t('readyToDiscover')}</p>
              <p className="h4">{t('ourServices')}</p>
            </div>
          </div>
          <div className="">
            <div className="container">
              <div className="row card-container">
                <div className="col-hover col-12 col-md-4 mb-24">
                  <ImgCard 
                    imgSrc={MLSimg}
                    altText={t('mlSolutions')}
                    title={t('mlSolutions')}
                    bodyText={t('mlSolutionsText')}
                  />
                </div>
                <div className="col-hover col-12 col-md-4 mb-24">
                  <ImgCard 
                    imgSrc={PredictiveImg}
                    altText={t('predictiveAnalytics')}
                    title={t('predictiveAnalytics')}
                    bodyText={t('predictiveText')}
                  />
                </div>
                <div className="col-hover col-12 col-md-4 mb-24">
                  <ImgCard
                    imgSrc={AIdrivenImg}
                    altText={t('aiBusinessConsulting')}
                    title={t('aiBusinessConsulting')}
                    bodyText={t('aiConsultingText')}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* Services */}
      <Footer />
    </div>
  );
}

export default AboutUs;